<!--begin::hero-->
<section
    class="position-relative d-flex align-items-center bg-light mb-0 py-lg-5 pt-5 bg-size-cover bg-position-center bg-repeat-0"
    style="background-image: url('assets/media/img/internal-banner1.png');height: 300px;">
    <span class="position-absolute top-0 start-0 w-100 h-100 bg-primary opacity-50"></span>
    <div class="container position-relative zindex-5">
        <div class="row justify-content-center">
            <div
                class="col-12 order-md-1 order-2 d-flex flex-column justify-content-between pt-2 align-items-center text-center">
                <!-- Text -->
                <h1 class="text-white h1 fw-semibold m-0 position-relative zindex-5"
                    *ngIf="IsRequiredPersonalInformation && url">
                    {{downloadpurpose}}
                </h1>
                <h1 class="text-white h1 fw-semibold m-0 position-relative zindex-5"
                    *ngIf="!IsRequiredPersonalInformation && url">
                    {{reportdownload}}
                </h1>
            </div>
        </div>
    </div>
</section>
<!--begin::breadcrumb-->
<section class="mb-5 bg-infoLight breadcrumb-containter">
    <div class="container">
        <div class="row">
            <div class="col m-3">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb m-0">
                        <li class="breadcrumb-item"><a href="/home" [innerText]="home" class="fs-sm fw-normal"></a></li>
                        <li class="breadcrumb-item fs-sm fw-normal active" aria-current="page"
                            *ngIf="IsRequiredPersonalInformation"> {{downloadpurpose}}
                        </li>
                        <li class="breadcrumb-item fs-sm fw-normal active" aria-current="page"
                            *ngIf="!IsRequiredPersonalInformation "> {{reportdownload}}
                        </li>
                    </ol>
                </nav>
            </div>
        </div>
    </div>
</section>


<!--begin::products-->
<div class="container">
    <h1 class="text-primary h3 mb-2">{{DocTitle}}</h1>
    <span class="d-block bg-secondary mt-1 mb-4" style="height: 0.35rem; width: 3.5rem;"></span>
    <form class="needs-validation" *ngIf="IsRequiredPersonalInformation">
        <!-- <h1  class="text-primary h3 mb-2">{{DocTitle}}</h1>
        <span class="d-block bg-secondary mt-1 mb-4" style="height: 0.35rem; width: 3.5rem;"></span> -->
        <!-- inputs -->
        <div class="row row-cols-lg-2 row-cols-1">
            <div class="col">
                <div class="input-group mb-3 position-relative">
                    <label class="form-label fs-sm fw-semibold w-100" for="name-input">{{nametxt}}</label>
                    <div class="position-relative w-100">
                        <input class="form-control ps-5" id="name" type="text" placeholder="{{nametxt}}"
                            [(ngModel)]="name" name="name">
                        <i
                            class="bx bx-user-circle fs-xl text-secondary position-absolute top-50 start-0 translate-middle-y ms-3 zindex-5 opacity-50"></i>
                    </div>
                    <!-- <div *ngIf="!nameF && submitted" class="text-danger fs-sm fw-semibold w-100">
                        {{requiredfield}}
                    </div> -->
                </div>
            </div>
            <div class="col">
                <div class="input-group mb-3">
                    <label class="form-label fs-sm fw-semibold w-100" for="tel-input">
                        {{mobilenumber}}</label>
                    <div class="position-relative w-100">
                        <input class="form-control ps-5" type="tel" id="mobile" placeholder="{{mobilenumber}} "
                            dir="rtl" [(ngModel)]="mobile" name="mobile">
                        <i
                            class="bx bx-phone fs-xl text-secondary position-absolute top-50 start-0 translate-middle-y ms-3 zindex-5 opacity-50"></i>
                    </div>
                    <!-- <div *ngIf="!mobileF && submitted" class="text-danger fs-sm fw-semibold w-100">
                        {{requiredfield}} </div> -->
                    <!-- <div *ngIf="!mobileForm && submitted" class="text-danger fs-sm fw-semibold w-100">
                        {{invalidmobilenumber}}
                    </div> -->
                </div>
            </div>
            <div class="col">
                <div class="input-group mb-3">
                    <label class="form-label fs-sm fw-semibold w-100" for="email-input">
                        {{emailResource}}
                    </label>
                    <div class="position-relative w-100">
                        <input class="form-control ps-5" type="email" id="email" placeholder="email@example.com"
                            dir="rtl" [(ngModel)]="email" name="email">
                        <i
                            class="bx bx-envelope-open fs-xl text-secondary position-absolute top-50 start-0 translate-middle-y ms-3 zindex-5 opacity-50"></i>
                    </div>
                    <div *ngIf="!emailV && submitted" class="text-danger fs-sm fw-semibold w-100">
                        {{requiredfield}} </div>
                    <div *ngIf="!emailForm && submitted" class="text-danger fs-sm fw-semibold w-100">
                        {{invalidemail}}

                    </div>
                </div>
            </div>
            <div class="col">
                <div class="input-group mb-3">
                    <label class="form-label fs-sm fw-semibold w-100" for="textarea-input">
                        {{downloadpurpose}}
                    </label>
                    <textarea class="form-control fs-md" id="textarea-input" rows="5" [(ngModel)]="why"
                        name="why"></textarea>
                    <!-- <div *ngIf="!whyF  && submitted" class="text-danger fs-sm fw-semibold w-100">
                        {{requiredfield}}
                    </div> -->
                </div>
            </div>
        </div>
        <!-- btns -->
        <div class="row row-cols-1 align-items-center">
            <div class="col">
                <div class="d-flex justify-content-center align-items-center ">
                    <button class="btn btn-primary fs-sm border-2 w-lg-25 w-sm-50 w-100 ms-2" style="margin-top:1.8rem"
                        (click)="send()" *ngIf=" !canDownload">{{reportdownload}}</button>



                    <!-- <a class="text-start w-100 text-decoration-none py-4 px-3 rounded-3 position-relative bg-primary text-white mb-3 h6 mb-0"
                    style="padding-top: 15px !important;padding-bottom: 15px !important;" target="_blank"
                    *ngIf=" submitted &&canDownload" href="{{this.url}}">
                    {{reportdownload}}
                    <div class="d-flex justify-content-center align-items-center bg-warning p-2 h-100 position-absolute top-50 end-0 translate-middle-y rounded-3"
                        style="width:55px;">
                        <i class="bx bx-cloud-download h2 text-white mb-0"></i>
                    </div>
                </a> -->
                </div>
            </div>
            <div class="col">
                <div class="d-flex justify-content-center align-items-center mt-3" *ngIf="submitted &&canDownload">
                    <a class="btn btn-primary fs-sm border-2 ms-2"
                        style="padding-top: 15px !important;padding-bottom: 15px !important;" target="_blank"
                        (click)="putVisitNo(id.toString())" 
                        href="{{urlJSON?.replace(imptempPublicUrl,imgPublicUrl)}}" *ngIf=" urlJSON">
                        JSON

                    </a>
                    <a class="btn btn-primary fs-sm border-2  ms-2"
                        style="padding-top: 15px !important;padding-bottom: 15px !important;" target="_blank"
                        (click)="putVisitNo(id.toString())" 
                        href="{{urlCSV?.replace(imptempPublicUrl,imgPublicUrl)}}" *ngIf=" urlCSV">
                        CSV
                    </a>
                    <a class="btn btn-primary fs-sm border-2  ms-2"
                        style="padding-top: 15px !important;padding-bottom: 15px !important;" target="_blank"
                        (click)="putVisitNo(id.toString())" 
                        href="{{urlExcel?.replace(imptempPublicUrl,imgPublicUrl)}}" *ngIf=" urlExcel">
                        Excel
                    </a>
                    <a class="btn btn-primary fs-sm border-2  ms-2"
                        style="padding-top: 15px !important;padding-bottom: 15px !important;" target="_blank"
                        (click)="putVisitNo(id.toString())" 
                        href="{{urlSPSS?.replace(imptempPublicUrl,imgPublicUrl)}}" *ngIf=" urlSPSS">
                        SPSS
                    </a>
                </div>
            </div>

        </div>


        <!-- <div class="row">
            <div class="col-12">
                
                <div class="d-md-flex">
                    <div class="w-100 me-4">



                    </div>
                    <div class="w-100">

                        <div class="mb-3 d-flex justify-content-end">
 
                        </div>
                    </div>
                    <div class="w-100">
                    <div class="row" *ngIf="submitted &&canDownload">
                        <div class="col  d-flex ">
                            {{DocTitle}}
                        </div>
                        <div class="col  d-flex ">
                            <a class="btn btn-primary fs-sm border-2 ms-2"
                            style="padding-top: 15px !important;padding-bottom: 15px !important;" target="_blank"
                            href="{{urlJSON?.replace(imptempPublicUrl,imgPublicUrl)}}"  *ngIf=" urlJSON">
                            JSON
                
                        </a>
                        <a class="btn btn-primary fs-sm border-2  ms-2"
                                style="padding-top: 15px !important;padding-bottom: 15px !important;" target="_blank"
                                href="{{urlCSV?.replace(imptempPublicUrl,imgPublicUrl)}}"  *ngIf=" urlCSV">
                                CSV
                            </a>
                            <a class="btn btn-primary fs-sm border-2  ms-2"
                            style="padding-top: 15px !important;padding-bottom: 15px !important;" target="_blank"
                            href="{{urlExcel?.replace(imptempPublicUrl,imgPublicUrl)}}"  *ngIf=" urlExcel">
                            Excel
                        </a>
                        <a class="btn btn-primary fs-sm border-2  ms-2"
                                style="padding-top: 15px !important;padding-bottom: 15px !important;" target="_blank"
                                href="{{urlSPSS?.replace(imptempPublicUrl,imgPublicUrl)}}"  *ngIf=" urlSPSS">
                                SPSS
                            </a>
                        </div>
                    </div>   
                    </div> 
                </div>

            </div>
        </div> -->
    </form>

    <div class="row" *ngIf="!IsRequiredPersonalInformation ">
        <!-- <div class="col  d-flex ">
            {{DocTitle}}
        </div> -->


        <div class="col  d-flex ">
            <a class="btn btn-primary fs-sm border-2 ms-2"
                style="padding-top: 15px !important;padding-bottom: 15px !important;" target="_blank"
                href="{{urlJSON?.replace(imptempPublicUrl,imgPublicUrl)}}"
                *ngIf="!IsRequiredPersonalInformation && urlJSON">
                JSON

            </a>
            <a class="btn btn-primary fs-sm border-2  ms-2"
                style="padding-top: 15px !important;padding-bottom: 15px !important;" target="_blank"
                href="{{urlCSV?.replace(imptempPublicUrl,imgPublicUrl)}}"
                *ngIf="!IsRequiredPersonalInformation && urlCSV">
                CSV
            </a>
            <a class="btn btn-primary fs-sm border-2  ms-2"
                style="padding-top: 15px !important;padding-bottom: 15px !important;" target="_blank"
                href="{{urlExcel?.replace(imptempPublicUrl,imgPublicUrl)}}"
                *ngIf="!IsRequiredPersonalInformation && urlExcel">
                Excel
            </a>
            <a class="btn btn-primary fs-sm border-2  ms-2"
                style="padding-top: 15px !important;padding-bottom: 15px !important;" target="_blank"
                href="{{urlSPSS?.replace(imptempPublicUrl,imgPublicUrl)}}"
                *ngIf="!IsRequiredPersonalInformation && urlSPSS">
                SPSS
            </a>
        </div>
    </div>
    <!-- <div class="row" *ngIf="!IsRequiredPersonalInformation && urlJSON">
        <div class="col  d-flex ">
            {{DocTitle}} 
        </div>
        <div class="col  d-flex ">
            <a class="btn btn-primary fs-sm border-2 ms-2"
                style="padding-top: 15px !important;padding-bottom: 15px !important;" target="_blank"
                href="{{urlJSON?.replace(imptempPublicUrl,imgPublicUrl)}}">
                JSON

            </a>
        </div>
    </div>
    <div class="row" *ngIf="!IsRequiredPersonalInformation && urlCSV">
        <div class="col  d-flex ">
            {{DocTitle}} 
        </div>
        <div class="col  d-flex ">
            <a class="btn btn-primary fs-sm border-2  ms-2"
                style="padding-top: 15px !important;padding-bottom: 15px !important;" target="_blank"
                href="{{urlCSV?.replace(imptempPublicUrl,imgPublicUrl)}}">
                CSV
            </a>
        </div>
    </div>
    <div class="row" *ngIf="!IsRequiredPersonalInformation && urlExcel">
        <div class="col  d-flex ">
            {{DocTitle}} 
        </div>
        <div class="col  d-flex ">
            <a class="btn btn-primary fs-sm border-2  ms-2"
                style="padding-top: 15px !important;padding-bottom: 15px !important;" target="_blank"
                href="{{urlExcel?.replace(imptempPublicUrl,imgPublicUrl)}}">
                Excel
            </a>
        </div>
    </div>
    <div class="row" *ngIf="!IsRequiredPersonalInformation && urlSPSS">
        <div class="col  d-flex ">
            {{DocTitle}} 
        </div>
        <div class="col  d-flex ">
            <a class="btn btn-primary fs-sm border-2  ms-2"
                style="padding-top: 15px !important;padding-bottom: 15px !important;" target="_blank"
                href="{{urlSPSS?.replace(imptempPublicUrl,imgPublicUrl)}}">
                SPSS
            </a>
        </div>
    </div> -->
</div>